import { __decorate, __extends, __read, __spreadArray, __values } from "tslib";
import { Component, Emit } from 'vue-property-decorator';
import Vue from 'vue-ltur';
import BaseFilter from "./BaseFilter";
import Analytics from "Helper/Analytics";
var BaseFilterBar = /** @class */ (function (_super) {
    __extends(BaseFilterBar, _super);
    function BaseFilterBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseFilterBar_1 = BaseFilterBar;
    BaseFilterBar.prototype.created = function () {
        this.map = {};
    };
    BaseFilterBar.prototype.mounted = function () {
        this.registrateFilter();
    };
    BaseFilterBar.prototype.pushFilter = function (filter) {
        if (!filter.track)
            return;
        if (this.map[filter.identifier]) {
            console.error("Filter is already defined: ".concat(filter.identifier, "!"));
            return;
        }
        this.map[filter.identifier] = filter;
        this.initializeFilter(filter);
        filter.$on('changeValue', this.onChange);
        filter.$on('dispatchFilter', this.onFilterDispatched);
    };
    BaseFilterBar.prototype.registrateFilter = function () {
        var e_1, _a;
        this.map = {};
        try {
            for (var _b = __values(this.findFilterRecurse()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                this.pushFilter(child);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.afterFiltersInitialized();
    };
    BaseFilterBar.prototype.findFilterRecurse = function (component) {
        var e_2, _a;
        if (component === void 0) { component = this; }
        var filterArray = new Array();
        try {
            for (var _b = __values(component.$children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (child instanceof BaseFilterBar_1)
                    continue;
                if (child instanceof BaseFilter) {
                    filterArray.push(child);
                }
                else {
                    var deepChildren = this.findFilterRecurse(child);
                    if (deepChildren.length > 0)
                        filterArray.push.apply(filterArray, __spreadArray([], __read(deepChildren), false));
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return filterArray;
    };
    BaseFilterBar.prototype.afterFiltersInitialized = function () {
    };
    BaseFilterBar.prototype.initializeFilter = function (filter) {
    };
    BaseFilterBar.prototype.onChange = function (filter) {
    };
    BaseFilterBar.prototype.onFilterDispatched = function (filter) {
    };
    BaseFilterBar.prototype.reset = function () {
        var e_3, _a;
        var _this = this;
        var userFilter = this.userFilter();
        var filterIdentifier = userFilter.map(function (f) { return f.identifier; });
        try {
            for (var userFilter_1 = __values(userFilter), userFilter_1_1 = userFilter_1.next(); !userFilter_1_1.done; userFilter_1_1 = userFilter_1.next()) {
                var filter = userFilter_1_1.value;
                filter.reset();
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (userFilter_1_1 && !userFilter_1_1.done && (_a = userFilter_1.return)) _a.call(userFilter_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        Analytics.trackRemoveAllFilters(filterIdentifier.map(function (f) { return JSON.parse(JSON.stringify(_this.map[f])); }));
    };
    BaseFilterBar.prototype.setFilter = function () {
        var e_4, _a;
        var _b;
        var filterList = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            filterList[_i] = arguments[_i];
        }
        try {
            for (var filterList_1 = __values(filterList), filterList_1_1 = filterList_1.next(); !filterList_1_1.done; filterList_1_1 = filterList_1.next()) {
                var filter = filterList_1_1.value;
                (_b = this.map[filter.identifier]) === null || _b === void 0 ? void 0 : _b.setFilter(filter.model);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (filterList_1_1 && !filterList_1_1.done && (_a = filterList_1.return)) _a.call(filterList_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    Object.defineProperty(BaseFilterBar.prototype, "filterMap", {
        get: function () {
            return this.map;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseFilterBar.prototype, "filter", {
        get: function () {
            return JSON.parse(JSON.stringify(this.map));
        },
        enumerable: false,
        configurable: true
    });
    BaseFilterBar.prototype.userFilter = function () {
        var e_5, _a;
        var userFilter = new Array();
        try {
            for (var _b = __values(Object.values(this.map)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var filter = _c.value;
                if (filter.isFilterModified())
                    userFilter.push(filter);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return userFilter;
    };
    var BaseFilterBar_1;
    __decorate([
        Emit('onChange')
    ], BaseFilterBar.prototype, "onChange", null);
    BaseFilterBar = BaseFilterBar_1 = __decorate([
        Component
    ], BaseFilterBar);
    return BaseFilterBar;
}(Vue));
export default BaseFilterBar;
